import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CartProductService } from '@app/api/api';

declare var $: any;

@Component({
  selector: 'meu-app-order-success',
  templateUrl: './app-order-success.component.html',
  styleUrls: ['./app-order-success.component.scss']
})
export class AppOrderSuccessComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private cartProductService: CartProductService,
  ) { }
    code: any ="";
    email: any="";
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.code = params.code;
      this.email = params.email;
    }
  );
    this.refreshCartState();
  }

  private refreshCartState(): void {
    this.cartProductService.apiMyCartProductsGet().subscribe((reslst) => {
      if (reslst.success) {
        if (reslst.data.collection.length === 0) {
          $('.numberOfProduct').text('');
        } else {
          $('.numberOfProduct').text(reslst.data.collection.length);
        }
      }
    });
  }

}
